import { Tabs } from "antd";
import {
  LayoutOutlined,
  FontSizeOutlined,
  PictureOutlined,
} from "@ant-design/icons";
import TemplatesPanel from "./TemplatesPanel";
import TextPanel from "./TextPanel";
import ImagesPanel from "./ImagesPanel";

export default function LeftSidebar(props) {
  const {
    templates,
    drafts,
    templatesLoading,
    draftsLoading,
    onApplyTemplate,
    onOpenDraft,
    templateCategory,
    onTemplateCategoryChange,
    onAddText,
    onImageUploaded,
    uploadLoading,
    sessionUploadImages,
    onAddSessionImageToCanvas,
    isLoggedIn,
  } = props;

  const items = [
    {
      key: "templates",
      label: (
        <span>
          <LayoutOutlined /> Templates
        </span>
      ),
      children: (
        <TemplatesPanel
          templates={templates}
          drafts={drafts}
          templatesLoading={templatesLoading}
          draftsLoading={draftsLoading}
          onApplyTemplate={onApplyTemplate}
          onOpenDraft={onOpenDraft}
          category={templateCategory}
          onCategoryChange={onTemplateCategoryChange}
          isLoggedIn={isLoggedIn}
        />
      ),
    },
    {
      key: "text",
      label: (
        <span>
          <FontSizeOutlined /> Text
        </span>
      ),
      children: <TextPanel onAddText={onAddText} />,
    },
    {
      key: "images",
      label: (
        <span>
          <PictureOutlined /> Images
        </span>
      ),
      children: (
        <ImagesPanel
          onImageUploaded={onImageUploaded}
          uploadLoading={uploadLoading}
          sessionUploadImages={sessionUploadImages}
          onAddSessionImageToCanvas={onAddSessionImageToCanvas}
          isLoggedIn={isLoggedIn}
        />
      ),
    },
  ];

  return (
    <div className="invitation-builder__left-sidebar">
      <Tabs defaultActiveKey="templates" items={items} />
    </div>
  );
}
